import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import SubscriptionCreditcard from './subscription-creditcard'
import SubscriptionConfirmationOrder from './subscription-confirmation-order'

/**
 * Controls the two-step update-payment-details modal flow.
 */
function UpdatePaymentDetails({ payload: initialPayload }) {
  const [{ step, payload }, setFlowState] = useState({
    step: 1,
    payload: initialPayload
  })

  const renderStep = useCallback((nextStep, nextPayload = {}) => {
    setFlowState({
      step: nextStep,
      payload: nextPayload
    })
  }, [])

  if (step === 2) {
    return <SubscriptionConfirmationOrder payload={payload} />
  }

  return <SubscriptionCreditcard renderStep={renderStep} />
}

UpdatePaymentDetails.propTypes = {
  payload: PropTypes.shape({
    orderId: PropTypes.string
  })
}

UpdatePaymentDetails.defaultProps = {
  payload: {}
}

export default UpdatePaymentDetails
